import React, { Component } from 'react';
import { AdminEventsResponseDto } from '../../../domain/audit/KeycloakAuditLogDomain';
import { Dialog } from 'primereact/dialog';
import { AuditLog, MenuPermission, Role } from '../../../domain/rbac/RbacDomains';
import moment from 'moment';
import LanguageUtil from '../../../util/LanguageUtil';

class AdminAuditDetailComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { audit } = this.props;
    let log: Record<string, any> = audit.document.data as unknown as Record<string, any>;
    return (
      <>
        <a
          className={'text-primary text-xs'}
          onClick={() => {
            this.setState({ isOpen: true });
          }}
        >
          {' '}
          {LanguageUtil.get({ id: 'pages.admin.audit.admin.openDetail', defaultMessage: 'Open Detail' })}
        </a>

        <Dialog
          header={LanguageUtil.get({ id: 'pages.admin.audit.admin.auditDetails', defaultMessage: 'Audit Details' })}
          headerClassName={'text-primary font-semibold text-md'}
          className={'w-[400px] text-sm'}
          visible={this.state.isOpen}
          onHide={() => this.setState({ isOpen: false })}
        >
          <div className={'flex flex-col gap-y-1 truncate'}>
            {log && Object.entries(log).some((f) => typeof f[1] !== 'object') ? (
              Object.entries(log)
                .filter(([key, value]) => this.permittedKeys().includes(key))
                .map(([key, value]) => {
                  return (
                    key &&
                    value && (
                      <span>
                        <p className={'text-primary font-semibold'}>{key}:</p>
                        <p className='overflow-auto'>{this.getValue(key, value)}</p>
                      </span>
                    )
                  );
                })
            ) : (
              <div>{LanguageUtil.get({ id: 'pages.admin.audit.admin.noChange', defaultMessage: 'There is no changes.' })}</div>
            )}
          </div>
        </Dialog>
      </>
    );
  }

  private getStringifyValue(value: any): string | null {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return null;
    }
  }

  private permittedKeys() {
    return ['firstName', 'lastName', 'role', 'roles', 'riskType', 'description', 'id', 'name', 'menu', 'enabled'];
  }

  private getValue(key: string, value: any) {
    if (Array.isArray(value) && (key == 'groups' || key == 'roles')) {
      return (
        <ul>
          {(value as string[]).map((v) => (
            <li>{v}</li>
          ))}
        </ul>
      );
    }
    if (Array.isArray(value) && key == 'menu') {
      return (
        <p className='flex flex-col gap-[5px]'>
          {(value as MenuPermission[]).map((v: MenuPermission) => {
            return (
              <p className='flex gap-[10px]'>
                <span>
                  {v.baseMenu} {'->'}{' '}
                </span>
                <span>{v.permission}</span>
              </p>
            );
          })}
        </p>
      );
    }
    if (typeof value === 'object' && value !== null) {
      return this.getStringifyValue(value);
    }
    if (typeof value == 'boolean') return value ? 'true' : 'false';
    if (key.toLowerCase().includes('date') && moment(value).isValid()) return moment(value).format('DD.MM.YYYY HH:mm:ss');
    return value;
  }
}

interface Props {
  audit: AuditLog;
}

class State {
  isOpen: boolean = false;
}

export default AdminAuditDetailComponent;
